import React, { forwardRef } from "react";
import { CopyIcon, IconButton, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import i18n from "~/i18n";

export const CopyButton = forwardRef(
  ({ open, size, value, label, tooltipText, iconClassName, onCopy, ...rest }, ref) => {
    return (
      <Tooltip title={tooltipText}>
        <IconButton
          onClick={() => onCopy(value, label)}
          {...rest}
          type="button"
          variant="text gray"
          size={size}
          active={open}
          ref={ref}
          className={classNames(iconClassName)}
        >
          <CopyIcon />
        </IconButton>
      </Tooltip>
    );
  }
);

CopyButton.propTypes = {
  open: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "big"]),
  value: PropTypes.string,
  label: PropTypes.string,
  tooltipText: PropTypes.string,
  iconClassName: PropTypes.string,
  onCopy: PropTypes.func,
};

CopyButton.defaultProps = {
  size: "small",
  tooltipText: i18n.t("Copy"),
};

CopyButton.displayName = "CopyButton";
